<div class="main-content">
    <div class="table-row table-header">
        <div class="col-index column">
            {{ 'ext-comm-settings.port.table.index' | translate }}
        </div>
        <div class="col-enabled column">
            {{ 'ext-comm-settings.port.table.enable' | translate }}
        </div>
        <div class="col-name column">
            {{ 'ext-comm-settings.port.table.name' | translate }}
        </div>
        <div class="col-options column"></div>
    </div>
    <div *ngFor="let port of ports; index as i" class="table-row" [class.disabledPort]="port.use == 0">
        <div class="col-index column">
            {{ port.port }}
        </div>
        <div class="col-enabled column" [class.disabledPort]="port.use == 0">
            <mat-checkbox
                [checked]="port.use === 1"
                (change)="port.use = $event.checked ? 1 : 0"
                (click)="$event.stopPropagation()"
                [disableRipple]="true">
            </mat-checkbox>
        </div>
        <div class="col-name column" [class.disabledPort]="port.use == 0">
            {{ port.name }}
        </div>
        <div class="col-options column" #iconButton [class.disabledPort]="port.use == 0">
            <mat-icon svgIcon="more-options" class="more-options" (click)="openOptions(port); $event.stopPropagation()">
            </mat-icon>
            <ng-container *ngIf="visiblePortOptions == port">
                <div class="more-options-container" #otherOptions>
                    <div class="option-row" (click)="edit(port, i)">
                        {{ 'dlg.edit' | translate }}
                    </div>
                    <div class="option-row" (click)="duplicate(port)">
                        {{ 'dlg.duplicate' | translate }}
                    </div>
                </div>
            </ng-container>
        </div>
    </div>
</div>
